function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import values from 'ramda/src/values';
import ApiConstants from 'invision-core/src/api/constants';
import ThunkHelper from 'invision-core/src/api/thunk.helper';
import { sendInventoryToStorePromise, submitOrderPromise } from './offering.order.actions';
import { buildAddressesRequestObject, buildCustomerRequestObject, buildCandidateBillCyclesRequest } from '../helpers/customer.helper';
import createWizardActions from '../helpers/offer.ordering.wizard.action.helper';
import { NEW_CONNECT_WIZARD_PREFIX } from '../constants/wizard.constants';
var wizardActions = createWizardActions(NEW_CONNECT_WIZARD_PREFIX);
export var BEGIN_NEW_CONNECT_ORDER = 'BEGIN_NEW_CONNECT_ORDER';
export var CANCEL_ORDER = wizardActions.CANCEL_WIZARD;
export var GO_TO_NEXT_STEP = wizardActions.GO_TO_NEXT_STEP;
export var GO_TO_PREVIOUS_STEP = wizardActions.GO_TO_PREVIOUS_STEP;
export var GO_TO_STEP = wizardActions.GO_TO_STEP;
export var RESTORE_OPTION_DEFAULT_PRICING = wizardActions.RESTORE_OPTION_DEFAULT_PRICING;
export var SAVE_OPTION_PRICING = wizardActions.SAVE_OPTION_PRICING;
export var SEND_PORT_IN_OR_ITEM_RESERVATION = wizardActions.SEND_PORT_IN_OR_ITEM_RESERVATION;
export var SET_ATTRIBUTE_SEARCHING_INVENTORY = wizardActions.SET_ATTRIBUTE_SEARCHING_INVENTORY;
export var SET_CURRENT_STEP_IS_INVALID = wizardActions.SET_CURRENT_STEP_IS_INVALID;
export var SET_EDIT_ATTRIBUTE_GROUPS = wizardActions.SET_EDIT_ATTRIBUTE_GROUPS;
export var SET_EDIT_CART_ADDITIONAL_PROPERTY = wizardActions.SET_EDIT_CART_ADDITIONAL_PROPERTY;
export var SET_EDIT_CART_ADDITIONAL_PROPERTY_ON_CHANGE = wizardActions.SET_EDIT_CART_ADDITIONAL_PROPERTY_ON_CHANGE;
export var SET_EDIT_OFFER_ADDITIONAL_PROPERTY = wizardActions.SET_EDIT_OFFER_ADDITIONAL_PROPERTY;
export var SET_EDIT_OFFER_ADDITIONAL_PROPERTY_ON_CHANGE = wizardActions.SET_EDIT_OFFER_ADDITIONAL_PROPERTY_ON_CHANGE;
export var SET_EDIT_OPTION = wizardActions.SET_EDIT_OPTION;
export var SET_EDIT_ORDER_ADDITIONAL_PROPERTY = wizardActions.SET_EDIT_ORDER_ADDITIONAL_PROPERTY;
export var SET_EDIT_ORDER_ADDITIONAL_PROPERTY_ON_CHANGE = wizardActions.SET_EDIT_ORDER_ADDITIONAL_PROPERTY_ON_CHANGE;
export var SET_EDIT_PHYSICAL_ATTRIBUTE_GROUPS = wizardActions.SET_EDIT_PHYSICAL_ATTRIBUTE_GROUPS;
export var SET_PAYMENT_INFO = wizardActions.SET_PAYMENT_INFO;
export var SET_SELECTED_FACETS_EDIT_COPY = wizardActions.SET_SELECTED_FACETS_EDIT_COPY;
export var SET_SELECTED_NEW_CONNECT_TAB = wizardActions.SET_SELECTED_WIZARD_TAB;
export var SET_SELECTED_OFFER = wizardActions.SET_SELECTED_OFFER;
export var SET_SELECTED_OFFER_EDIT_COPY = wizardActions.SET_SELECTED_OFFER_EDIT_COPY;
export var SET_SELECTED_OFFERING_CHARGE_TYPES_EDIT_COPY = wizardActions.SET_SELECTED_OFFERING_CHARGE_TYPES_EDIT_COPY;
export var UPDATE_BILL_CYCLE = wizardActions.UPDATE_BILL_CYCLE;
export var UPDATE_CUSTOMER_INFO = 'UPDATE_CUSTOMER_INFO';
export var UPDATE_CUSTOMER_INFO_EDIT_COPY = 'UPDATE_CUSTOMER_INFO_EDIT_COPY';
export var UPDATE_EDIT_BRI_PRICE = wizardActions.UPDATE_EDIT_BRI_PRICE;
export var UPDATE_INVENTORY_SELECTION = wizardActions.UPDATE_INVENTORY_SELECTION;
export var UPDATE_OFFER_ATTRIBUTE = wizardActions.UPDATE_OFFER_ATTRIBUTE;
export var UPDATE_OFFER_PHYSICAL_INVENTORY_MAKE_AND_MODEL = wizardActions.UPDATE_OFFER_PHYSICAL_INVENTORY_MAKE_AND_MODEL;
export var UPDATE_OFFER_PHYSICAL_INVENTORY_TYPE_ATTRIBUTE = wizardActions.UPDATE_OFFER_PHYSICAL_INVENTORY_TYPE_ATTRIBUTE;
export var UPDATE_PAYMENT_INFO = wizardActions.UPDATE_PAYMENT_INFO;
export var UPDATE_PORT_IN_REQUEST = wizardActions.UPDATE_PORT_IN_REQUEST;
export var UPDATE_SELECTED_SERVICE_FEATURES = wizardActions.UPDATE_SELECTED_SERVICE_FEATURES;
export var UPDATE_SHOPPING_CART = wizardActions.UPDATE_SHOPPING_CART;
export var CREATE_CUSTOMER_ORDER_WIZARD = {
  BEGIN: 'CREATE_CUSTOMER_ORDER_WIZARD_BEGIN',
  SUCCESS: 'CREATE_CUSTOMER_ORDER_WIZARD_SUCCESS',
  FAILURE: 'CREATE_CUSTOMER_ORDER_WIZARD_FAILURE'
};
export var RETRIEVE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_ORDER_WIZARD = {
  BEGIN: 'RETRIEVE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_ORDER_WIZARD_BEGIN',
  SUCCESS: 'RETRIEVE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_ORDER_WIZARD_SUCCESS',
  FAILURE: 'RETRIEVE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_ORDER_WIZARD_FAILURE'
};
export var UPDATE_CUSTOMER_ADDRESS_ORDER_WIZARD = {
  BEGIN: 'UPDATE_CUSTOMER_ADDRESS_WIZARD_BEGIN',
  SUCCESS: 'UPDATE_CUSTOMER_ADDRESS_WIZARD_SUCCESS',
  FAILURE: 'UPDATE_CUSTOMER_ADDRESS_WIZARD_FAILURE'
};
export var UPDATE_CUSTOMER_ORDER_WIZARD = {
  BEGIN: 'UPDATE_CUSTOMER_ORDER_WIZARD_BEGIN',
  SUCCESS: 'UPDATE_CUSTOMER_ORDER_WIZARD_SUCCESS',
  FAILURE: 'UPDATE_CUSTOMER_ORDER_WIZARD_FAILURE'
};
export var RETRIEVE_CANDIDATE_BILL_CYCLES = {
  BEGIN: 'RETRIEVE_CANDIDATE_BILL_CYCLES_BEGIN',
  SUCCESS: 'RETRIEVE_CANDIDATE_BILL_CYCLES_SUCCESS',
  FAILURE: 'RETRIEVE_CANDIDATE_BILL_CYCLES_FAILURE'
};
export var cancelOrder = wizardActions.cancelWizard;
export var clearQuoteAndSetSelectedOffer = wizardActions.clearQuoteAndSetSelectedOffer;
export var fetchAttributes = wizardActions.fetchAttributes;
export var fetchAttributesAndNavigate = wizardActions.fetchAttributesAndNavigate;
export var fetchDecisionsAndNavigate = wizardActions.fetchDecisionsAndNavigate;
export var goToNextStep = wizardActions.goToNextStep;
export var goToPreviousStep = wizardActions.goToPreviousStep;
export var goToStep = wizardActions.goToStep;
export var restoreOptionDefaultPricing = wizardActions.restoreOptionDefaultPricing;
export var saveBulkPricing = wizardActions.saveBulkPricing;
export var searchAttributeInventory = wizardActions.searchAttributeInventory;
export var sendPortInOrItemReservation = wizardActions.sendPortInOrItemReservation;
export var setCurrentStepIsInvalid = wizardActions.setCurrentStepIsInvalid;
export var setEditAttributeGroups = wizardActions.setEditAttributeGroups;
export var setEditCartAdditionalProperty = wizardActions.setEditCartAdditionalProperty;
export var setEditCartAdditionalPropertyOnChange = wizardActions.setEditCartAdditionalPropertyOnChange;
export var setEditOfferAdditionalProperty = wizardActions.setEditOfferAdditionalProperty;
export var setEditOfferAdditionalPropertyOnChange = wizardActions.setEditOfferAdditionalPropertyOnChange;
export var setEditOption = wizardActions.setEditOption;
export var setEditOrderAdditionalProperty = wizardActions.setEditOrderAdditionalProperty;
export var setEditOrderAdditionalPropertyOnChange = wizardActions.setEditOrderAdditionalPropertyOnChange;
export var setEditPhysicalAttributeGroups = wizardActions.setEditPhysicalAttributeGroups;
export var setPaymentInfo = wizardActions.setPaymentInfo;
export var setSelectedFacetsEditCopy = wizardActions.setSelectedFacetsEditCopy;
export var setSelectedOfferEditCopy = wizardActions.setSelectedOfferEditCopy;
export var setSelectedOfferingChargeTypesEditCopy = wizardActions.setSelectedOfferingChargeTypesEditCopy;
export var setSelectedTab = wizardActions.setSelectedTab;
export var updateAttribute = wizardActions.updateAttribute;
export var updateBillCycle = wizardActions.updateBillCycle;
export var updateCart = wizardActions.updateCart;
export var updateEditOptionPrice = wizardActions.updateEditOptionPrice;
export var updateInventorySelection = wizardActions.updateInventorySelection;
export var updateOfferPhysicalInventoryMakeAndModel = wizardActions.updateOfferPhysicalInventoryMakeAndModel;
export var updateOfferPhysicalInventoryTypeAttribute = wizardActions.updateOfferPhysicalInventoryTypeAttribute;
export var updatePaymentInfo = wizardActions.updatePaymentInfo;
export var updatePortInRequest = wizardActions.updatePortInRequest;
export var updateSelectedServiceFeatures = wizardActions.updateSelectedServiceFeatures;
export var updateShoppingCartPromise = wizardActions.updateShoppingCartPromise;
export var beginNewConnectOrder = function beginNewConnectOrder() {
  return {
    type: BEGIN_NEW_CONNECT_ORDER
  };
};
export var updateCustomerInfo = function updateCustomerInfo(customerInfoObj) {
  return {
    type: UPDATE_CUSTOMER_INFO,
    payload: customerInfoObj
  };
};
export var updateCustomerInfoEditCopy = function updateCustomerInfoEditCopy(customerInfoObj) {
  return {
    type: UPDATE_CUSTOMER_INFO_EDIT_COPY,
    payload: customerInfoObj
  };
};
export var updateCustomerInfoEditCopyPromise = function updateCustomerInfoEditCopyPromise(customerInfoObj) {
  return function (dispatch) {
    dispatch(updateCustomerInfoEditCopy(customerInfoObj));
    return Promise.resolve();
  };
};
export var navigateToFetchOffers = function navigateToFetchOffers() {
  return function (dispatch) {
    dispatch(goToNextStep());
    return Promise.resolve();
  };
};
var retrieveConvergentBillerSubscriberSummaryPromise = function retrieveConvergentBillerSubscriberSummaryPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, values(RETRIEVE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_ORDER_WIZARD), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveConvergentBillerSubscriberSummary',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
var createCustomerPromise = function createCustomerPromise(dispatch, customer, additionalOptions, paymentInstrument) {
  var paymentInstruments = paymentInstrument ? {
    PaymentInstruments: [paymentInstrument]
  } : null;
  return ThunkHelper(dispatch, values(CREATE_CUSTOMER_ORDER_WIZARD), {
    method: 'post',
    url: 'SubscriberManagement/CreateSubscriber',
    data: Object.assign(buildCustomerRequestObject(customer), additionalOptions, paymentInstruments)
  });
};
export var createCustomer = function createCustomer(customer, preventOverride) {
  return function (dispatch) {
    var addressesOption = buildAddressesRequestObject(customer, null, preventOverride);
    return createCustomerPromise(dispatch, customer, addressesOption);
  };
};
export var createCustomerAndSaveOrder = function createCustomerAndSaveOrder(customer, shoppingCart, redemptionCodes, additionalOptions, paymentInfo, preventOverride) {
  return function (dispatch) {
    var addressesOption = buildAddressesRequestObject(customer, null, preventOverride);
    return createCustomerPromise(dispatch, customer, addressesOption, paymentInfo).then(function (response) {
      var subscriberId = response.Subscriber.Id;
      return updateShoppingCartPromise(dispatch, subscriberId, shoppingCart, redemptionCodes, additionalOptions);
    });
  };
};
export var createCustomerAndSendOrderToStore = function createCustomerAndSendOrderToStore(customer, shoppingCart, inventoryStorePickupDetails, preventOverride) {
  return function (dispatch) {
    var addressesOption = buildAddressesRequestObject(customer, null, preventOverride);
    return createCustomerPromise(dispatch, customer, addressesOption).then(function (response) {
      var subscriberId = response.Subscriber.Id;
      return sendInventoryToStorePromise(dispatch, subscriberId, shoppingCart, inventoryStorePickupDetails);
    });
  };
};
export var sendOrderToStore = function sendOrderToStore(customer, shoppingCart, inventoryStorePickupDetails) {
  return function (dispatch) {
    var subscriberId = customer.Subscriber.Id;
    return sendInventoryToStorePromise(dispatch, subscriberId, shoppingCart, inventoryStorePickupDetails);
  };
};
export var updateCustomerAndSaveOrder = function updateCustomerAndSaveOrder(oldCustomerData, newCustomerData, shoppingCart, redemptionCodes, additionalOptions) {
  return function (dispatch) {
    var customerId = oldCustomerData.Subscriber.Id;
    return updateCustomerPromise(dispatch, newCustomerData, oldCustomerData, customerId).then(function () {
      return updateAddressPromise(dispatch, customerId, newCustomerData, oldCustomerData.Addresses[0].Id);
    }).then(function () {
      return updateShoppingCartPromise(dispatch, customerId, shoppingCart, redemptionCodes, additionalOptions);
    });
  };
};
export var saveOrder = function saveOrder(oldCustomerData, shoppingCart, redemptionCodes, additionalOptions) {
  return function (dispatch) {
    var customerId = oldCustomerData.Subscriber.Id;
    return updateShoppingCartPromise(dispatch, customerId, shoppingCart, redemptionCodes, additionalOptions);
  };
};
export var updateCustomerAndSendOrderToStore = function updateCustomerAndSendOrderToStore(oldCustomerData, newCustomerData, shoppingCart, inventoryStorePickupDetails) {
  return function (dispatch) {
    var customerId = oldCustomerData.Subscriber.Id;
    return updateCustomerPromise(dispatch, newCustomerData, oldCustomerData, customerId).then(function () {
      return updateAddressPromise(dispatch, customerId, newCustomerData, oldCustomerData.Addresses[0].Id);
    }).then(function () {
      return sendInventoryToStorePromise(dispatch, customerId, shoppingCart, inventoryStorePickupDetails);
    });
  };
};
export var updateCustomer = function updateCustomer(oldCustomerData, newCustomerData) {
  return function (dispatch) {
    var customerId = oldCustomerData.Subscriber.Id;
    return updateCustomerPromise(dispatch, newCustomerData, oldCustomerData, customerId);
  };
};
var updateCustomerPromise = function updateCustomerPromise(dispatch, newCustomerData, oldCustomerData, customerId) {
  // merge data from the oldCustomerData and newCustomerData.
  // this is done to retain any important pieces of info in oldCustomerData that need to be round-tripped back to the api.
  // example: ConvergentBillerId.
  var mergedCustomerData = Object.assign({}, oldCustomerData.Subscriber, newCustomerData);

  //when guid is present in old subscriber then it should be used as login
  mergedCustomerData.Login = oldCustomerData.Subscriber.Login && !newCustomerData.Login ? oldCustomerData.Subscriber.Login : newCustomerData.Login;
  var requestObj = buildCustomerRequestObject(mergedCustomerData);
  // Credentials are not updated via this API call, so don't send it.
  delete requestObj.Credentials;
  // Even if Language is not required in the createCustomer api call it's _ALWAYS_ required for the updateCustomer call!
  requestObj.Subscriber.Language = requestObj.Subscriber.Language || oldCustomerData.Subscriber.Language;
  return ThunkHelper(dispatch, values(UPDATE_CUSTOMER_ORDER_WIZARD), {
    method: 'post',
    url: 'SubscriberManagement/UpdateSubscriber',
    data: requestObj,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
var updateAddressPromise = function updateAddressPromise(dispatch, customerId, customerData, addressId) {
  return ThunkHelper(dispatch, values(UPDATE_CUSTOMER_ADDRESS_ORDER_WIZARD), {
    method: 'post',
    url: 'SubscriberManagement/UpdateAddress',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      Address: {
        City: customerData.city,
        Country: customerData.country,
        DefaultBilling: true,
        DefaultHome: true,
        DefaultPostal: true,
        DefaultService: true,
        Id: addressId,
        LineOne: customerData.addressLine1,
        LineTwo: customerData.addressLine2 ? customerData.addressLine2 : undefined,
        Name: customerData.addressLine1,
        // Name is required by the API and needs to be unique.
        PostalCode: customerData.postalCode,
        State: customerData.stateRegionProvince
      },
      TextScrubberOverride: customerData.textScrubber || undefined
    }
  });
};
var configureAutoPayPromise = function configureAutoPayPromise(dispatch, customerId, paymentInfo, convergentBillerAccounts) {
  if (!paymentInfo || !paymentInfo.AutoPay) {
    // Autopay is not configured, so skip this step
    return Promise.resolve(paymentInfo);
  } else if (paymentInfo.AutoPay) {
    if (convergentBillerAccounts) {
      // we have the account data in Redux already!
      var convergentBillerPaymentAccounts = convergentBillerAccounts.map(function (x) {
        return {
          AccountNumber: x.AccountNumber,
          AutoPay: true
        };
      });
      paymentInfo = Object.assign({}, paymentInfo, {
        ConvergentBillerPaymentInstrumentAccounts: convergentBillerPaymentAccounts
      });
      return Promise.resolve(paymentInfo);
    } else {
      // we don't have the account information so we need to get it by calling an API
      return retrieveConvergentBillerSubscriberSummaryPromise(dispatch, customerId).then(function (response) {
        var convergentBillerPaymentAccounts = response.SubscriberSummary.AccountSummaries.map(function (x) {
          return {
            AccountNumber: x.AccountNumber,
            AutoPay: true
          };
        });
        paymentInfo = Object.assign({}, paymentInfo, {
          ConvergentBillerPaymentInstrumentAccounts: convergentBillerPaymentAccounts
        });
        return Promise.resolve(paymentInfo);
      });
    }
  }
};
export var updateCustomerAndSubmitOrder = function updateCustomerAndSubmitOrder(dto, shippingInfo) {
  return function (dispatch) {
    return updateCustomerPromise(dispatch, dto.newCustomerData, dto.oldCustomerData, dto.customerId).then(function () {
      return updateAddressPromise(dispatch, dto.customerId, dto.newCustomerData, dto.oldCustomerData.Addresses[0].Id);
    }).then(function () {
      return configureAutoPayPromise(dispatch, dto.customerId, dto.paymentInfo, dto.convergentBillerAccounts);
    }).then(function (response) {
      dto.paymentInfo = response;
      if (dto.paymentInfo && dto.paymentInfo.BillingAddressIsServiceAddress) {
        dto.paymentInfo = Object.assign({}, dto.paymentInfo, {
          BillingAddressId: dto.oldCustomerData.Addresses[0].Id
        });
      }
      var customerInfo = {
        'Id': dto.customerId,
        'SubtenantId': dto.subtenantId,
        'Language': dto.customerLanguage
      };
      return submitOrderPromise(dispatch, customerInfo, dto.shoppingCart, dto.paymentInfo, dto.billCycleName, dto.executionOptions, dto.recordPaymentInfo, false, dto.additionalProperties, shippingInfo, dto.offerAdditionalProperties);
    });
  };
};
export var updateAddress = function updateAddress(oldCustomerData, newCustomerData) {
  return function (dispatch) {
    var customerId = oldCustomerData.Subscriber.Id;
    return updateAddressPromise(dispatch, customerId, newCustomerData, oldCustomerData.Addresses[0].Id);
  };
};
export var submitOrder = function submitOrder(dto, shippingInfo) {
  return function (dispatch) {
    return configureAutoPayPromise(dispatch, dto.customerId, dto.paymentInfo, dto.convergentBillerAccounts).then(function (response) {
      dto.paymentInfo = response;
      if (dto.paymentInfo && dto.paymentInfo.BillingAddressIsServiceAddress) {
        dto.paymentInfo = Object.assign({}, dto.paymentInfo, {
          BillingAddressId: dto.oldCustomerData.Addresses[0].Id
        });
      }
      var customerInfo = {
        'Id': dto.customerId,
        'SubtenantId': dto.subtenantId,
        'Language': dto.customerLanguage
      };
      return submitOrderPromise(dispatch, customerInfo, dto.shoppingCart, dto.paymentInfo, dto.billCycleName, dto.executionOptions, dto.recordPaymentInfo, false, dto.additionalProperties, shippingInfo, dto.orderDetails, dto.offerAdditionalProperties);
    });
  };
};
export var retrieveCandidateBillCyclesNewConnectPromise = function retrieveCandidateBillCyclesNewConnectPromise(dispatch, orderType, customerCategory, currency, customerType, country, state) {
  return ThunkHelper(dispatch, values(RETRIEVE_CANDIDATE_BILL_CYCLES), {
    method: 'post',
    url: 'SubscriberManagement/EvaluateBillCycleRules',
    data: buildCandidateBillCyclesRequest(orderType, customerCategory, customerType, currency, country, state)
  });
};
export var retrieveCandidateBillCyclesNewConnect = function retrieveCandidateBillCyclesNewConnect(orderType, customerCategory, currency, customerType, country) {
  var state = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  return function (dispatch) {
    return retrieveCandidateBillCyclesNewConnectPromise(dispatch, orderType, customerCategory, currency, customerType, country, state);
  };
};